import { useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import api from "../api/api";


export default function ResetPassword() {

    const { token } = useParams();

    const [searchParams] = useSearchParams();

    const email = searchParams.get("email");

    const navigate = useNavigate();


    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const [loading, setLoading] = useState(false);



    const handleSubmit = async (e) => {

        e.preventDefault();

        setError("");
        setMessage("");


        if (password !== confirmPassword) {

            setError("Passwords do not match");
            return;

        }


        setLoading(true);


        try {


            await api.post("/reset-password", {

                token,
                email,
                password,
                password_confirmation: confirmPassword

            });


            setMessage(
                "Password reset successfully. Redirecting to login..."
            );


            setTimeout(() => {

                navigate("/");

            }, 3000);



        } catch (err) {

            console.log(err);

            setError(
                err.response?.data?.message ||
                "Unable to reset password"
            );

        }


        setLoading(false);


    }




    return (

        <div className="
        min-h-screen
        flex
        items-center
        justify-center
        bg-gray-100
        dark:bg-gray-950
        px-5
        ">


            <div className="
            w-full
            max-w-md
            bg-white
            dark:bg-gray-900
            rounded-3xl
            shadow-xl
            p-8
            ">


                <h1 className="
                text-3xl
                font-bold
                text-center
                mb-6
                dark:text-white
                ">
                    Reset Password
                </h1>



                {
                    error &&
                    <div className="
                    bg-red-100
                    text-red-600
                    p-3
                    rounded-xl
                    mb-5
                    ">
                        {error}
                    </div>
                }



                {
                    message &&
                    <div className="
                    bg-green-100
                    text-green-700
                    p-3
                    rounded-xl
                    mb-5
                    ">
                        {message}
                    </div>
                }



                <form
                    onSubmit={handleSubmit}
                    className="space-y-5"
                >


                    <input

                        type="password"

                        placeholder="New Password"

                        value={password}

                        onChange={(e) => setPassword(e.target.value)}

                        className="
                    w-full
                    px-5
                    py-4
                    rounded-2xl
                    border
                    dark:bg-gray-800
                    dark:text-white
                    "

                    />



                    <input

                        type="password"

                        placeholder="Confirm Password"

                        value={confirmPassword}

                        onChange={(e) => setConfirmPassword(e.target.value)}

                        className="
                    w-full
                    px-5
                    py-4
                    rounded-2xl
                    border
                    dark:bg-gray-800
                    dark:text-white
                    "

                    />



                    <button

                        disabled={loading}

                        className="
                    w-full
                    py-4
                    rounded-2xl
                    font-bold
                    bg-gradient-to-r
                    from-[#D9BB74]
                    to-[#B89442]
                    text-black
                    "

                    >

                        {
                            loading
                                ?
                                "Updating..."
                                :
                                "Reset Password"
                        }

                    </button>


                </form>


            </div>


        </div>

    );

}